import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  Router,
  ActivatedRoute,
} from '@angular/router';

import { AuthService } from '../services/auth.service';

@Component({
  selector: 'sws-loginpage',
  templateUrl: './loginpage.component.html',
  styleUrls: ['./loginpage.component.css']
})
export class LoginpageComponent implements OnInit {
  message: string;
  username: string;
  password: string = "";
  angemeldet: boolean;

  constructor(public authService: AuthService,
              private router: Router ) {
    this.message = '';
    
  }


  ngOnInit() {
  }

  anmelden() {
    this.angemeldet = this.login(this.username, this.password);
    if ( this.angemeldet === true )
      {
        this.router.navigateByUrl('/infopage');
      }
    this.router.navigateByUrl('/home');
  }

  /* Anmeldung */
  login(username: string, password: string): boolean {
    this.message = '';
    if (!this.authService.login(username, password)) {
      this.message = 'Benutzername oder Kennwort falsch.';
      setTimeout(function() {
        this.message = '';
      }.bind(this), 2500);
    }
    return false;
  }

  /* Abmeldung */
  logout() {
    this.authService.logout();
    this.router.navigateByUrl('/home');
  }
  

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/loginpage/loginpage.component.ts